<div class="modal-content rounded-4 shadow-lg border-0 p-4">
  <!-- En-tête -->
  <div class="modal-header border-0 position-relative">
    <div class="text-center w-100">
      <img
        src="./assets/logo1.png"
        alt="AfricaRent"
        class="mb-3"
        style="height: 130px;"
      >
      <h5 class="modal-title fw-bold fs-3" id="connexionLabel">
        Se connecter
      </h5>
    </div>
    <button
      type="button"
      class="btn-close position-absolute top-0 end-0 m-3"
      data-bs-dismiss="modal"
      aria-label="Fermer" (click)="ActivalModal.close()">
    </button>
  </div>

  <!-- Corps -->
  <div class="modal-body px-5">
    <form [formGroup]="reactiveForm_login_login" (ngSubmit)="onSubmit_login_login()" #form_login_login="ngForm" class="needs-validation" novalidate>

      <!-- Champ téléphone -->
      <div class="mb-4">
        <label for="loginInput" class="form-label fs-5">Téléphone *</label>
        <input
          type="text"
          id="loginInput"
          class="form-control  rounded-3"
          placeholder="Entrez votre numéro"
          formControlName="login"
          [ngClass]="{ 'is-invalid': submitted && f.login.errors }"
          required
        >
        @if (submitted && f.login.errors) {
          <div class="invalid-feedback">
            @if (f.login.errors.required) {
              <div>Ce champ est obligatoire</div>
            }
          </div>
        }
      </div>

      <!-- Champ mot de passe -->
      <div class="mb-1">
        <label for="passwordInput" class="form-label fs-5">Mot de passe *</label>
        <div class="input-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="passwordInput"
            class="form-control rounded-3"
            placeholder="Entrez votre mot de passe"
            formControlName="pwd"
            [ngClass]="{ 'is-invalid': submitted && f.pwd.errors }"
            required
          >
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="togglePasswordVisibility()"
            aria-label="Afficher/masquer le mot de passe">
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        @if (submitted && f.pwd.errors) {
          <div class="invalid-feedback">
            @if (f.pwd.errors.required) {
              <div>Ce champ est obligatoire</div>
            }
          </div>
        }
      </div>

      <!-- Lien mot de passe oublié -->
      <div class="text-end mt-2 mb-4">
        <a href="#" class="text-danger text-decoration-none small">
          Mot de passe oublié ?
        </a>
      </div>

      <!-- Bouton de validation -->
      <div class="d-grid">
        <button
          type="submit"
          class="btn btn-success btn-lg rounded-pill py-3 fw-semibold fs-5"
          [disabled]="loading_login_login">
          {{loading_login_login ? "En cours ..." : "Valider"}}
        </button>
      </div>

    </form>
  </div>

  <!-- Pied de modal -->
  <div class="modal-footer border-0 justify-content-center">
    <small class="fs-6">
      Vous n'avez pas de compte ?
      <a
        href="#"
        (click)="openInscription()"
        class="text-success fw-semibold"
        data-bs-toggle="modal"
        data-bs-target="#inscriptionModal"
        data-bs-dismiss="modal">
        S'inscrire ici
      </a>
    </small>
  </div>
</div>
